/**
 * AppMain — Canonical <main> scroll container + inner gutter frame.
 *
 * Matches the Kloutforce golden standard:
 *   <main class="min-w-0 flex-1 overflow-y-auto overflow-x-hidden min-h-0">
 *     <div class="p-4 md:p-6 min-h-0">…</div>
 *   </main>
 */
import * as React from 'react';
import { cn } from '../../lib/utils';

export interface AppMainProps {
  children: React.ReactNode;
  /** Extra classes on <main> */
  className?: string;
  /** Extra classes on the inner gutter frame */
  frameClassName?: string;
  /** Use normal document scrolling instead of making <main> the scroll root. */
  documentScroll?: boolean;
}

export const AppMain = React.forwardRef<HTMLElement, AppMainProps>(
  ({ children, className, frameClassName, documentScroll = false }, ref) => (
    <main
      ref={ref}
      className={cn(
        documentScroll
          ? 'min-w-0 flex-1 overflow-x-clip'
          : 'min-w-0 flex-1 overflow-y-auto overflow-x-hidden min-h-0',
        className,
      )}
    >
      <div className={cn('p-4 md:p-6 min-h-0', frameClassName)}>{children}</div>
    </main>
  ),
);

AppMain.displayName = 'AppMain';
